import { render, staticRenderFns } from "./movimenti.vue?vue&type=template&id=6aea8a88&"
import script from "./movimenti.vue?vue&type=script&lang=ts&"
export * from "./movimenti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports